// config is resolved on the main thread and handed to the worker in its first
// message, so the published worker is a static, environment agnostic asset.
let config = {};
// configure analytics. call once during app startup, before the first tracked event.
export function configureAnalytics(cfg) {
    config = cfg;
}
/** @internal test helper */
export function resetAnalyticsConfig() {
    config = {};
}
export function getAnalyticsConfig() {
    return config;
}
